import React from "react";
import { TimelineList } from "./TimelineList";

export const Education = ({ data }) => (
  <TimelineList
    items={(data?.education || [])
      .map((item) => ({
        title: item.degree || "",
        subtitle: item.institution?.trim() || null,
        duration: item.start_date || item.end_date ? `${item.start_date || ""} – ${item.end_date || ""}` : null,
        description: item.field_of_study || null,
      }))
      .filter((item) => item.title?.trim() || item.subtitle?.trim() || item.duration?.toString().trim() || item.description?.trim())}
    dotColor="#059669"
  />
);

export default Education;
